import React, { Component } from 'react';
import Modal from '../Modal/Modal';
import { toggleModal } from '../Modal/modalActions';
import { getDataByUniqueModalName } from '../Modal/modalViewState';
import { transactionShape } from '../../utils/propTypes';
import { connect } from 'react-redux';
import { refundTransaction } from './refundActions';
import PropTypes from 'prop-types';
import {
    EmvioValidatedButton,
    EmvioValidatedForm,
    EmvioValidatedInput,
    EmvioValidatedTextArea
} from '@nexio/emvio-form-components';
import {
    currencyMapper,
    doesPropExistAndHasItChanged,
    gatewayType,
    prettifyMoney,
    asyncGatewayList
} from '@nexio/emvio-util-app';
import {
    getIsRefundLoadingById,
    getIsRefundSuccessfulById,
    getRefundErrorMessageById
} from './refundEntity';
import {
    arrayOfStringsToStringWithSeparator,
    getGoodAmountNumber,
    prettifyDate
} from '../../utils/string';
import { toast } from 'react-toastify';
import _ from 'lodash';
import './Refund.scss';

export class Refund extends Component {
    static propTypes = {
        error: PropTypes.string,
        isLoading: PropTypes.bool,
        isSuccessful: PropTypes.bool,
        onRefundTransaction: PropTypes.func,
        onToggleModal: PropTypes.func,
        transaction: transactionShape
    };

    static defaultProps = {
        transaction: {}
    };

    constructor(props) {
        super(props);

        this.handleRefund = this.handleRefund.bind(this);
        this.onUpdateAmount = this.onUpdateAmount.bind(this);
        this.onUpdateArbitraryInput = this.onUpdateArbitraryInput.bind(this);

        this.state = {
            amount: '0'
        };
    }

    componentDidUpdate(prevProps) {
        const gatewayType = _.get(this.props, 'transaction.gateway.gatewayType');
        const asyncGateway = _.find(asyncGatewayList, { gatewayType });
        const refundIsAsync = _.get(asyncGateway, 'refundIsAsync') || false;
        if (doesPropExistAndHasItChanged(prevProps, this.props, 'isSuccessful') && this.props.isSuccessful === true) {
            const toastMessage = refundIsAsync ? 'Refund request received' : 'Refund successful';
            this.props.onToggleModal(this.props.transaction);
            toast(toastMessage, { type: 'success' });
        }

        if (doesPropExistAndHasItChanged(prevProps, this.props, 'transaction')) {
            const amount = _.get(this.props, 'transaction.foreignProcessingCurrency.amount') || _.get(this.props, 'transaction.amount');
            const currencyId = _.get(this.props, 'transaction.foreignProcessingCurrency.currencyId') || _.get(this.props, 'transaction.currencyId');
            const decimalPlaces = _.get(currencyMapper, `${currencyId}.decimalPlaces`);
            this.setState({ amount: getGoodAmountNumber(amount, decimalPlaces) });
        }
    }

    renderAttribute(title = '', value) {
        if (value) {
            return (
                <div className="attribute">
                    <div className="title">{title.toUpperCase()}</div>
                    <div className="value">{value}</div>
                </div>
            );
        }

        return null;
    }

    handleRefund(e) {
        e.preventDefault();

        if (!this.props.isLoading) {
            this.props.onRefundTransaction(this.props.transaction, this.state.amount, this.state.refundReason);
        }
    }

    onUpdateAmount(e) {
        const amount = e.target.value;

        this.setState({ amount });
    }

    onUpdateArbitraryInput(e) {
        const container = {};
        container[e.target.name] = e.target.value;

        this.setState({ ...container });
    }

    render() {
        const { transaction } = this.props;

        const customerFirstName = _.get(transaction, 'customer.firstName', '');
        const customerLastName = _.get(transaction, 'customer.lastName', '');
        const customerName = arrayOfStringsToStringWithSeparator([customerFirstName, customerLastName]);

        const amount = _.get(transaction, 'foreignProcessingCurrency.amount') || _.get(transaction, 'amount');
        const currencyId = _.get(transaction, 'foreignProcessingCurrency.currencyId') || _.get(transaction, 'currencyId', '840');
        const currency = currencyMapper[currencyId].code;

        const gatewaysThatRequireRefundReason = [
            gatewayType.payments_os_colombia
        ];

        let disallowPartialRefunds = false;
        if (_.includes([gatewayType.payments_os_colombia], _.get(transaction, 'gateway.gatewayType'))){
            disallowPartialRefunds = true;
        }

        let refundRequiresInput = null;
        if (_.includes(gatewaysThatRequireRefundReason, _.get(transaction, 'gateway.gatewayType'))) {
            refundRequiresInput =
                <div className="input">
                    <EmvioValidatedTextArea
                        autoCapitalize="off"
                        autoCorrect="off"
                        autoFocus
                        characterLimit="250"
                        labelText="REFUND REASON"
                        name="refundReason"
                        onChange={this.onUpdateArbitraryInput}
                        placeholder="Enter Refund Reason..."
                        type="text"
                        validations={['required', 'maximumLengthN', 'noSensitiveData']}
                    />
                </div>;
        }

        return (
            <Modal uniqueModalName="refund" title="Refund Transaction">
                <EmvioValidatedForm className="emvio-refund-popup" onSubmit={this.handleRefund}>
                    {this.renderAttribute('Customer', customerName)}
                    {this.renderAttribute('Date', prettifyDate(transaction.transactionDate))}
                    {this.renderAttribute('Reference Number', _.get(transaction, 'gateway.refNumber'))}
                    {this.renderAttribute('Amount', `${prettifyMoney(amount, currency)} ${_.toUpper(currency)}`)}
                    { disallowPartialRefunds ? null : <div className="input">
                        <EmvioValidatedInput
                            autoCapitalize="off"
                            autoCorrect="off"
                            autoFocus
                            invert
                            labelText="REFUND AMOUNT"
                            largeMode
                            name="amount"
                            onChange={this.onUpdateAmount}
                            placeholder="0.00"
                            shouldEnforceNumber
                            type="text"
                            validations={['required']}
                            value={`${this.state.amount}`}
                        />
                    </div> }
                    {refundRequiresInput}
                    { disallowPartialRefunds ? null : <div className="help-text">
                        The amount can only be adjusted to be less than or equal to the transaction amount.
                    </div> }
                    <EmvioValidatedButton
                        className={ refundRequiresInput ? 'extra-spacing' : '' }
                        invertColors
                        isLoading={this.props.isLoading}
                    >
                        Refund {`${prettifyMoney(this.state.amount, currency)} ${_.toUpper(currency)}`}
                    </EmvioValidatedButton>
                </EmvioValidatedForm>
            </Modal>
        );
    }
}

function mapStateToProps(state) {
    const transaction = getDataByUniqueModalName(state, 'refund');
    const id = _.get(transaction, 'id');

    return {
        error: getRefundErrorMessageById(state, id),
        isLoading: getIsRefundLoadingById(state, id),
        isSuccessful: getIsRefundSuccessfulById(state, id),
        transaction
    };
}

function mapDispatchToProps(dispatch) {
    return {
        onRefundTransaction: (transaction, amountToRefund, refundReason) => dispatch(refundTransaction(transaction.id, amountToRefund, refundReason)),
        onToggleModal: (transaction) => dispatch(toggleModal('refund', transaction))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Refund);
